import styled from "@emotion/styled";
import { UnsetButton } from "../buttons";
import { FlexColContainer } from "../layout";
import { useMemo } from "react";

const StyledFootnoteOption = styled(UnsetButton)<{ selected?: boolean }>(
  ({ selected }) => ({
    width: "89px",
    height: "69px",
    boxShadow: selected
      ? `0 -6px 12px -2px inset rgba(255, 255, 255, 1),
        0 0 0 0.5px inset rgba(237, 236, 229, 1),
        0 0 4px 2px inset rgba(186, 183, 168, 1)`
      : `0 1px 4px 0 rgba(9, 9, 11, 0.08),
        0 -17px 10px -1px inset rgba(250, 249, 244, 1),
        0 0 0 0.5px inset rgba(255, 255, 255, 1),
        0 0 4px 2px inset rgba(253, 253, 251, 1)`,
    borderRadius: "8px",
    backgroundColor: selected
      ? "rgba(211, 209, 199, 1)"
      : "rgba(252, 251, 248, 1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }),
);

type FootnoteOptionProps = {
  updateFootnoteOption: (
    footnote: PrismaJson.EreaderSettings["footnotes"] | undefined,
  ) => void;
  footnoteLabel?: PrismaJson.EreaderSettings["footnotes"];
  selected?: boolean;
};

export const FootnoteOption = ({
  footnoteLabel,
  updateFootnoteOption,
  selected,
}: FootnoteOptionProps) => {
  const footnoteTitle = useMemo(() => {
    return footnoteLabel === "clickToShow"
      ? "Hide Inline Footnotes"
      : footnoteLabel === "inline"
        ? "Show Inline Footnotes"
        : undefined;
  }, [footnoteLabel]);
  return (
    <StyledFootnoteOption
      onClick={() => {
        updateFootnoteOption(footnoteLabel);
      }}
      title={footnoteTitle}
      selected={selected}
    >
      <FlexColContainer
        style={{ alignItems: "center", justifyContent: "center" }}
      >
        <div
          style={{
            fontSize: "12px",
            textAlign: "center",
          }}
        >
          {footnoteTitle}
        </div>
      </FlexColContainer>
    </StyledFootnoteOption>
  );
};
